import config from './config.json';
import { randomUUID } from './lib/uuid.ts';

export const getConfig = (url: string) => {
  const makeTabVersion = () => {
    const rand = randomUUID().substring(0, 4);
    const dateObj = new Date();
    const date = [
      `${dateObj.getFullYear()}`,
      ...[
        dateObj.getMonth() + 1,
        dateObj.getDate(),
        dateObj.getHours(),
        dateObj.getMinutes(),
        dateObj.getSeconds(),
      ].map(num => `${num}`.padStart(2, '0')),
    ].join('');
    return `${rand}${date}z`;
  };

  const { hostname, origin, protocol, port } = new URL(url);
  const PREVIEW_RE = /preview\.sorare\.(?=(dev|tech)$)/;

  const getEnvConfigFromDomain = () => {
    if (hostname.match(PREVIEW_RE)) {
      return {
        ...(hostname.endsWith('.tech') ? config.mockprod : config.staging),
        walletUrl: origin.replace(PREVIEW_RE, 'preview.wallet.sorare.'),
      };
    }
    if (hostname.match(/sorare\.dev/)) {
      return config.staging;
    }
    if (hostname.match(/sorare\.tech/)) {
      return config.mockprod;
    }
    if (hostname.match(/sorare\.co$/)) {
      return {
        ...config.production,
        backendHost: config.production.backendHost.replace(
          'sorare.com',
          'sorare.co'
        ),
        walletUrl: config.production.walletUrl.replace(
          'sorare.com',
          'sorare.co'
        ),
        wsUrl: config.production.wsUrl.replace('sorare.com', 'sorare.co'),
      };
    }
    if (hostname.match(/localhost|(192\.168\..*\..*)|(10\.0\.2\.2)|\.local$/)) {
      if (port === '4242') {
        // vitest
        return config.development;
      }
      let envConfig;
      switch (port) {
        case '4003':
          envConfig = config.mockprod;
          break;
        case '5003':
          envConfig = config.staging;
          break;
        case '6003':
        case '3000':
          envConfig = config.development;
          break;
        default:
          envConfig = config.production;
          break;
      }
      const walletUrl = new URL(config.development.walletUrl);
      return {
        ...envConfig,
        walletUrl: `${protocol}//${hostname}:${walletUrl.port}`,
        backendHost: `${origin}/${envConfig.env}/api`,
        launchDarklyClientSideID: config.development.launchDarklyClientSideID,
        wsUrl: `${protocol === 'https:' ? 'wss' : 'ws'}://${hostname}:${port}/${envConfig.env}/ws`,
      };
    }

    return config.production;
  };

  return {
    __CONFIG__: getEnvConfigFromDomain(),
    __TAB_VERSION__: makeTabVersion(),
    __VERSION__: import.meta.env.DEV
      ? new Date().toISOString().replace(/[-T:]/g, '').slice(0, 14)
      : Number(import.meta.env.VITE_TIMESTAMP_VERSION),
  };
};
